import 'css-chunksrc/client/scenes/calendar/week/dayCreationMenu/participantsPicker/styles.scss';export default {
  "field": "_field_a2e15_2",
  "label": "_label_a2e15_8",
  "participants": "_participants_a2e15_14",
  "participantAvatar": "_participantAvatar_a2e15_21",
  "addParticipantRoot": "_addParticipantRoot_a2e15_49",
  "addParticipantIcon": "_addParticipantIcon_a2e15_54",
  "participantsMenu": "_participantsMenu_a2e15_64",
  "participantsMenuUpward": "_participantsMenuUpward_a2e15_70"
};